import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { useVoiceAgentOps } from './useVoiceAgentOps'
import { VoiceAgentOpsComponent } from './VoiceAgentOpsComponent'

/**
 * Ops tab body for the AI Voice Agent page (super users only; the page only offers the
 * tab to them). An `observer`, because `useVoiceAgentOps` reads `VoiceAgentOpsStore`
 * observables during this render: loading a scope, or picking a filter, re-renders here.
 */
export const VoiceAgentOpsTab = observer(function VoiceAgentOpsTab(): ReactElement {
  const hookData = useVoiceAgentOps()
  return <VoiceAgentOpsComponent {...hookData} />
})
